module.exports = __webpack_public_path__ + "img/no-data.929e41d4.svg";